"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const config_1 = __importDefault(require("../config"));
const UnsupportedBrowserBanner_1 = __importDefault(require("../../UnsupportedBrowserBanner"));
const HeaderDesktop_1 = __importDefault(require("../HeaderDesktop"));
const HeaderMobile_1 = __importDefault(require("../HeaderMobile"));
const LazyHydrate_1 = __importDefault(require("../../LazyHydrate"));
const styles = require('./HeaderLayout.module.scss');
const HeaderContainer = ({ browser, cookies, displayUserStatus, hasBody, isSticky, isUserStatusLoading, userStatus, }) => {
    const { nodes } = config_1.default;
    const { isAuthenticated, name: userName, links: { login: loginLink, register: registerLink, logout: logoutLink, account: accountLink }, } = userStatus || {
        isAuthenticated: false,
        name: '',
        links: { login: '', register: '', logout: '', account: '' },
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)({ [styles.body]: hasBody, [styles.sticky]: isSticky }) },
        react_1.default.createElement(UnsupportedBrowserBanner_1.default, { cookies: cookies, browser: browser }),
        react_1.default.createElement("header", { className: styles.header },
            react_1.default.createElement(LazyHydrate_1.default, { whenIdle: true },
                react_1.default.createElement(HeaderDesktop_1.default, { accountLink: accountLink, displayUserStatus: displayUserStatus && !isUserStatusLoading, isAuthenticated: isAuthenticated, loginLink: loginLink, logoutLink: logoutLink, nodes: nodes, registerLink: registerLink, userName: userName })),
            react_1.default.createElement(HeaderMobile_1.default, { accountLink: accountLink, isUserStatusLoading: isUserStatusLoading, isAuthenticated: isAuthenticated, loginLink: loginLink, logoutLink: logoutLink, nodes: nodes, registerLink: registerLink, userName: userName }))));
};
exports.default = HeaderContainer;
//# sourceMappingURL=HeaderLayout.js.map